import {AString} from '@mintdata/mint-kit/api/values/AString';
import {AStringEnum} from '@mintdata/mint-kit/api/values/AStringEnum';

export class BorderFill extends AStringEnum
{
    public constructor(value:AString)
    {
        super(value, BorderFill.types);
    }

    public toString():string
    {
        return this.value ? this.value.toString() : null;
    }

    public static fromString(value:string):BorderFill
    {
        return new BorderFill(AString.fromString(value));
    }

    public static ALL = new AString('borderAll');
    public static TOP = new AString('borderTop');
    public static BOTTOM = new AString('borderBottom');
    public static LEFT = new AString('borderLeft');
    public static RIGHT = new AString('borderRight');

    public static types:Array<AString> = [
        BorderFill.LEFT,
        BorderFill.TOP,
        BorderFill.RIGHT,
        BorderFill.BOTTOM,
        BorderFill.ALL,
    ];

    public static all():BorderFill
    {
        return new BorderFill(BorderFill.ALL);
    }

    public static top():BorderFill
    {
        return new BorderFill(BorderFill.TOP);
    }

    public static bottom():BorderFill
    {
        return new BorderFill(BorderFill.BOTTOM);
    }

    public static left():BorderFill
    {
        return new BorderFill(BorderFill.LEFT);
    }

    public static right():BorderFill
    {
        return new BorderFill(BorderFill.RIGHT);
    }

    public static isAll(fill:BorderFill):boolean
    {
        return fill && fill.value.isEqualTo(BorderFill.ALL);
    }

    public static isTop(fill:BorderFill):boolean
    {
        return fill && fill.value.isEqualTo(BorderFill.TOP);
    }

    public static isBottom(fill:BorderFill):boolean
    {
        return fill && fill.value.isEqualTo(BorderFill.BOTTOM);
    }

    public static isLeft(fill:BorderFill):boolean
    {
        return fill && fill.value.isEqualTo(BorderFill.LEFT);
    }

    public static isRight(fill:BorderFill):boolean
    {
        return fill && fill.value.isEqualTo(BorderFill.RIGHT);
    }
}
